import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 50px 40px;
  align-items: center;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.hoverGray};
  }

  > img {
    width: 100%;
    max-width: 80px;
    max-height: 80px;
    min-width: 80px;
    min-height: 80px;
    object-fit: contain;
  }

  > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const AreaTitlePart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  &&& {
    .MuiFormControl-root {
      border-radius: 4px;
    }

    .MuiInputBase-root {
      border: 1px solid ${({ theme }) => theme.grayDark};
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 2px;
    }
  }
`;

interface IAreaInputs {
  $numColumns: number;
}
export const AreaInputs = styled.div<IAreaInputs>`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.$numColumns}, 1fr)`};
  gap: 0.3rem;
`;

export const RowPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;
